export const pseudoBefore =
  'before:absolute before:left-0 before:top-0 before:h-[2px] before:w-full before:transition-transform'
export const pseudoAfter =
  'after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-full after:transition-transform'
